import React from 'react';
import { motion } from 'framer-motion';
export function Collaborators() {
  // Note: These are placeholder names as requested
  const collaborators = ['IIT Bombay', 'IIT Delhi', 'NUS Singapore', 'DRDO', 'ISRO', 'Tata Motors', 'Mahindra', 'Samsung R&D', 'Boeing India'];
  return <section id="collaborators" className="py-20 bg-white border-t border-gray-100 overflow-hidden" data-id="element-49">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-50">
        <div className="text-center mb-12" data-id="element-51">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-3xl font-bold text-[#800000] font-serif mb-3" data-id="element-52">
            Our Collaborators
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-gray-600" data-id="element-53">
            17 collaborating institutions and organizations worldwide
          </motion.p>
        </div>

        {/* Simple Grid for Badges */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-4 max-w-4xl mx-auto" data-id="element-54">
          {collaborators.map((name, index) => <div key={index} className="px-6 py-3 bg-[#FAF9F7] border border-[#800000]/20 rounded-full text-gray-800 font-medium text-sm hover:border-[#800000] hover:bg-[#800000]/5 transition-colors cursor-default" data-id="element-55">
              {name}
            </div>)}
        </motion.div>
      </div>
    </section>;
}